export var inputPortalTokens = {
  borderWidth: 2,

  /*
   * Общий отступ пришлось разделить на paddingX + marginX
   * Это нужно, чтоб у браузерной заливка автозаполненного инпута появлялся отсутп, иначе оч. некрасиво
   */
  sizes: {
    // x - 12, y -7
    s: {
      // 12 = 5 + 7
      paddingX: 5,
      marginX: 7,
      // 7 = 2 + 5
      paddingY: 2,
      marginY: 5,
      // Отступ от префикса/постфикса/clear-button до содержимого ипунта
      prefixInnerPadding: 10,
      borderRadius: 4,
      iconsSize: 24
    },
    // x - 14, y - 10
    m: {
      // 14 = 6 + 8
      paddingX: 6,
      marginX: 8,
      // 10 = 4 + 6
      paddingY: 4,
      marginY: 6,
      prefixInnerPadding: 10,
      borderRadius: 6,
      iconsSize: 24
    },
    // x - 16, y - 12
    l: {
      // 16 = 7 + 9
      paddingX: 7,
      marginX: 9,
      // 12 = 5 + 7
      paddingY: 5,
      marginY: 7,
      prefixInnerPadding: 10,
      borderRadius: 8,
      iconsSize: 24
    }
  },
  focusBoxShadowAttrs: "0 0 3px 1px",
  colors: {
    base: function base(_ref) {
      var color = _ref.color;
      return color.border.input.base;
    },
    baseHover: function baseHover(_ref2) {
      var color = _ref2.color;
      return color.border.input.hover;
    },
    invalidBase: function invalidBase(_ref3) {
      var color = _ref3.color;
      return color.border.input.invalid.base;
    },
    invalidHover: function invalidHover(_ref4) {
      var color = _ref4.color;
      return color.border.input.invalid.hover;
    },
    focusBase: function focusBase(_ref5) {
      var color = _ref5.color;
      return color.border.focus.base;
    },
    focusHover: function focusHover(_ref6) {
      var color = _ref6.color;
      return color.border.focus.hover;
    },
    focusInvalid: function focusInvalid(_ref7) {
      var color = _ref7.color;
      return color.border.focus.invalid.base;
    },
    focusInvalidHover: function focusInvalidHover(_ref8) {
      var color = _ref8.color;
      return color.border.focus.invalid.hover;
    },
    placeholder: function placeholder(_ref9) {
      var color = _ref9.color;
      return color.text.placeholder.base;
    },
    placeholderDisabled: function placeholderDisabled(_ref10) {
      var color = _ref10.color;
      return color.text.placeholder.disable;
    },
    text: function text(_ref11) {
      var color = _ref11.color;
      return color.text.black.base;
    },
    fill: "#FFF",
    fillDisabled: "#FFF",
    opacityOnDisable: 0.5
  }
};